/**
 * Beeldgalerij met miniaturen.
 *
 * De AnimatePresence-crossfade uit de React-versie is hier een CSS-transitie
 * op opacity: alle beelden staan gestapeld, alleen de actieve is zichtbaar.
 * Zonder JS staat het eerste beeld er gewoon, dus de pagina blijft bruikbaar.
 */
class FoleaGallery extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll("[data-slide]")];
    this.thumbs = [...this.querySelectorAll("[data-thumb]")];
    if (this.thumbs.length < 2) return;

    this.onClick = this.onClick.bind(this);
    this.thumbs.forEach((thumb) => thumb.addEventListener("click", this.onClick));
    this.select(0);
  }

  disconnectedCallback() {
    this.thumbs?.forEach((thumb) => thumb.removeEventListener("click", this.onClick));
  }

  onClick(event) {
    this.select(this.thumbs.indexOf(event.currentTarget));
  }

  select(index) {
    this.slides.forEach((slide, i) => {
      slide.dataset.active = String(i === index);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.dataset.active = String(i === index);
      thumb.setAttribute("aria-pressed", String(i === index));
    });
  }
}

if (!customElements.get("folea-gallery")) {
  customElements.define("folea-gallery", FoleaGallery);
}
